import { section } from '@/neon';

import productItem from '@/components/productItem';
import scrollIntoView from '@/lib/scrollIntoView';

const selectors = {
  products: '.product-item',
  animatedItems: '.animates',
};

section('featured-collection-grid', {
  onLoad() {
    this.animatedItems = this.container.querySelectorAll(
      selectors.animatedItems
    );

    const products = this.container.querySelectorAll(selectors.products);
    this.productItems = [];

    products.forEach(element => {
      this.productItems.push(productItem(element));
    });

    if (this.animatedItems.length) {
      this.scrollAnimation = scrollIntoView(this.container, this.animatedItems);
    }
  },

  onUnload() {
    this.productItems.forEach(item => item.unload());

    this.animatedItems.length && this.scrollAnimation.unload();
  },
});
